<template>
  <div class="container-fluid">
    <div class="main">
      <div class="header">
        <img src="../assets/theme/header.png">
      </div>
      <div class="banner"><img src="../assets/banner/n1.png"></div>
      <div class="content">
        <div class="l-content">
          <!-- <div class="l-bolck">
            <div class="banner">
              <img src="../assets/banner/b5.png">
            </div>
          </div> -->
          <TodayResult />
          <div class="l-bolck">
            <div class="banner banner-bottom">
              <img src="../assets/banner/n2.png">
            </div>
            <!-- <div class="banner banner-bottom mt-2">
              <img src="../assets/banner/b3.png">
            </div>
            <div class="banner banner-bottom mt-2">
              <img src="../assets/banner/b2.png">
            </div> -->
          </div>
        </div>
        <div class="r-content">
          <!-- <div class="banner">
            <img src="../assets/banner/b1.png">
          </div> -->
          <HistoryResults />
          <div class="banner">
            <img src="../assets/banner/n3.png">
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-inner">
        Copyright {{y}} ©laounionvip.com
      </div>
    </div>
  </div>
</template>
<script>
import TodayResult from './components/TodayResult.vue'
import HistoryResults from './components/HistoryResults.vue'
import moment from "@/moment"

export default {
  components: {
    TodayResult,
    HistoryResults
  },
  computed: {
    y() {
      return moment().format("Y")
    }
  }
}
</script>
<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background-image: url('../assets/theme/bg.png');
  background-repeat: repeat-x;
  background-position: center top;
}

.container-fluid {
  // border-top: 10px solid #07A9E1;
  padding: 0;

  .banner {
    img {
      width: 100%;
      max-width: 100%;
    }
  }

  .main {
    width: 1050px;
    max-width: 100%;
    margin: 0 auto;

    .header {
      // height: 153px;
      background-repeat: repeat-y;
      background-position: center top;
      background-color: #00CAF4;
      display: flex;
      align-items: center;
      padding-bottom: 5px;
      border-bottom: 4px solid #FFF;

      img {
        max-width: 100%;
      }
    }

    .content {
      display: flex;
      margin-top: 10px;

      .l-content {
        width: 440px;

        .now-result {
          border: 3px solid #07A9E1;
          // padding: 5px;
          background-color: #EEE;
          background-image: url('../assets/theme/n.png');
          background-repeat: repeat-x;
          background-position: center bottom;
          margin-bottom: 10px;

          .result-head {
            padding-bottom: 5px;
            background-color: #EEE;

            h2 {
              text-align: center;
              font-size: 1.3rem;
              margin-top: 10px;
            }
            h1 {
              text-align: center;
              font-size: 4rem;
              font-weight: bold;
              letter-spacing: 5px;
            }
            h3 {
              text-align: center;
              font-size: 1.2rem;
              font-weight: normal;
            }
          }

          .table {
            background-color: #FFF;
            text-align: center;
            margin-bottom: 0px;
            tr {
              td {
                padding: 5px;
                font-size: 1.5rem;
                border: 2px solid #dee2e6;
              }
            }
          }
        }

        .l-bolck {
          margin-bottom: 10px;
          //min-height: 200px;
          // border: 1px solid #eee;
          //padding: 5px;
          background-color: #FFF;
          /*background-image: url('../assets/theme/n2.png');
          background-repeat: repeat-x;
          background-position: center bottom;*/

          .banner {
            img {
              width: 100%;
              max-width: 100%;
            }
          }
        }
      }
      .r-content {
        width: calc(100% - 450px);
        margin-left: 10px;

        .banner {
          margin-bottom: 10px;
          img {
            width: 100%;
            max-width: 100%;
          }
        }
      }
    }

    .content-b {
      //margin-top: 15px;
      margin-right: -5px;
      margin-left: -5px;
      display: flex;

      .banner {
        width: 33.3%;
        padding: 5px;
        img {
          max-width: 100%;
          border: 1px solid #EEE;
        }
      }
    }
  }

  .footer {
    margin-top: 25px;
    border-top: 4px solid #07A9E1;

    .footer-inner {
      margin-top: 10px;
      text-align: center;
      background-color: #07A9E1;
      padding: 15px;
      color: #FFF;
    }
  }
}

@media only screen and (max-width:767px) {
  .container-fluid .main .content {
    display: block;
    .l-content {
      width: 100%;

      .banner-bottom {
        display: none;
      }
    }
    .r-content {
      width: 100%;
      margin-left: 0px;
      margin-top: 15px;
    }
  }
}

@media only screen and (max-width:500px) {
  .container-fluid .main .content .r-content {
    table.table {
      font-size: 15px;
    }
  }
  .container-fluid .main .content-b {
    display: block;
    padding: 0 10px;
    .banner {
      width: 100%;
    }
  }
}
</style>
